import { useState } from "react";
import crypto from "crypto-js";
const SSOHandler = () => {
  const [ssodata, setssodata] = useState("");
  const decript_data = (payload, app) => {
    const ciphertext = crypto.AES.decrypt(payload, app.sso).toString(
      crypto.enc.Utf8
    );
    setssodata(ciphertext);
  };
  const checkSSO = (app) => {
    // decript_data(
    //   "U2FsdGVkX19jIkzumPlCydFaaaNCl3QD8HYPqOmgM8ph6mUdtaE30q4+wIhz9KaTiqox4nIuYA8UlNwCZb+uLg9S+XtcRjav6AwJKSR2CrqnQD1H/6Ox8IU8fpvDlS0ZEjKIQ0bFDTlWwhY2Vyyf7Ab3xhTjwqKo1yvsqEssFYZZEOIaLGq6ohM7W7mn2jhzZ7/mjaf/uA35JwFBtyDxE7aI56brAGcdXzMq55Wwfbro3+vWPI9XeBlqlAGv2z7Q",
    //   { sso: "32ee586f-a904-49d8-8b77-63cc417cf828" }
    // );

    const key = new Promise((resolve) => {
      window.parent.postMessage({ message: "REQUEST_USER_DATA" }, "*");
      const temp = window.addEventListener("message", ({ data }) => {
        if (data.message === "REQUEST_USER_DATA_RESPONSE") {
          decript_data(data.payload, app);
        } else {
        }
      });
    });
  };
  return {
    SSO: ssodata,
    checkSSO: checkSSO,
  };
};
export default SSOHandler;
